var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTranslate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.16 18.0933L12.7733 14.7466L12.8133 14.7066C15.1333 12.12 16.7867 9.14663 17.76 5.99996H21.6667V3.33329H12.3333V0.666626H9.66668V3.33329H0.333344V5.98663H15.2267C14.3333 8.55996 12.92 11 11 13.1333C9.76001 11.76 8.73334 10.2533 7.92001 8.66663H5.25334C6.22668 10.84 7.56001 12.8933 9.22668 14.7466L2.44001 21.44L4.33334 23.3333L11 16.6666L15.1467 20.8133L16.16 18.0933ZM23.6667 11.3333H21L15 27.3333H17.6667L19.16 23.3333H25.4933L27 27.3333H29.6667L23.6667 11.3333ZM20.1733 20.6666L22.3333 14.8933L24.4933 20.6666H20.1733Z",
    fill: "#1f2e3d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslate);
export default __webpack_public_path__ + "static/media/translate.daa837159aac3b8402e1d57f3b0f79ae.svg";
export { ForwardRef as ReactComponent };